import merchantStates from '@/dictionaries/merchantStates'

export const merchants = {
    state: {
        status: 'idle',
        merchants: [],
        merchantSearch: '',
        selectAllMerchants: false
    },
    mutations: {
        SET_MERCHANTS(state, payload) {
            state.merchants = payload
        },
        SET_MERCHANTS_STATUS(state, payload) {
            state.status = payload
        },
        SET_MERCHANT_SEARCH(state, payload) {
            state.merchantSearch = payload
        },
        SET_SELECT_ALL_SHOPS(state, payload) {
            state.selectAllMerchants = payload
        }
    },
    actions: {
        merchantsFetch({ state, commit, getters }, payload) {
            if (state.status === 'idle') {
                commit('SET_MERCHANTS_STATUS', 'loading')
                const params = {
                    page: 1,
                    per: 99999,
                    location_id: payload?.locationIds,
                    includes: 'network'
                }

                return this.$api
                    .get('merchants', {
                        params
                    })
                    .then(response => {
                        if (response.data.data.length > 0) {
                            commit('SET_MERCHANTS', response.data.data)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        commit('SET_MERCHANTS_STATUS', 'idle')
                    })
            }
        },
        setMerchants({ commit }, payload) {
            commit('SET_MERCHANTS', payload)
        },
        searchMerchants({ dispatch, commit }, payload) {
            dispatch('setSelectAllSubscriptions', false)
            commit('SET_MERCHANT_SEARCH', payload)
        },
        setSelectAllMerchants({ commit }, payload) {
            commit('SET_SELECT_ALL_SHOPS', payload)
        },
        selectShop({ commit, getters, dispatch }, payload) {
            const selectedGroup = getters.getSelectedPromoGroup(payload.groupId)
            if (
                selectedGroup?.acceptance === 'all' ||
                payload.fromPromoDetails
            ) {
                dispatch('selectGroupMerchant', {
                    groupId: payload.groupId,
                    merchantId: payload.shopId
                })
            }
            const { previewType } = payload
            let promo

            if (previewType === 'labels') {
                promo = getters.getSelectedLabelPromo(payload)
            } else {
                promo = getters.getSelectedPromoGroupPromoItem(payload)
            }

            let subscriptions
            if (payload.equalPrices) {
                subscriptions =
                    promo.subscriptionsEqualPrices.priceGroups[payload.groupIdx]
            } else {
                subscriptions = promo.subscriptions
            }

            const shopSubs = subscriptions.find(
                el => el.merchant_id === payload.shopId
            )
            if (shopSubs) {
                shopSubs.checked = payload.value
            }

            let mutationName
            if (previewType === 'labels') {
                mutationName = 'SET_LABELPROMO_SELECTED_SHOPS'
            } else {
                mutationName = 'SET_PROMO_SELECTED_SHOPS'
            }

            commit(mutationName, {
                promoId: payload.promoId,
                subscriptions,
                equalPrices: payload.equalPrices,
                groupIdx: payload.groupIdx,
                groupId: payload.promotion.groupId ?? payload.groupId
            })
            if (!payload.value) {
                dispatch('setSelectAllMerchants', payload.value)
            }
            dispatch('checkPricesErrors')
            if (payload.equalPrices) {
                dispatch('recreatePriceGroups', {
                    promoId: payload.promoId,
                    groupId: payload.groupId,
                    previewType
                })
            }
        },
        selectAllMerchants({ commit, getters, dispatch }, payload) {
            const selectedGroup = getters.getSelectedPromoGroup(
                payload.promotion.groupId
            )
            if (
                selectedGroup?.acceptance === 'all' ||
                payload.fromPromoDetails
            ) {
                dispatch('selectGroupMerchants', {
                    groupId: payload.promotion.groupId,
                    value: payload.value
                })
            }
            const { previewType } = payload
            let selectedPromotion

            if (previewType === 'labels') {
                selectedPromotion = getters.getSelectedLabelPromo({
                    promoId: payload.promoId,
                    groupId: payload.promotion.groupId
                })
            } else {
                selectedPromotion = getters.getSelectedPromoGroupPromoItem({
                    promoId: payload.promoId,
                    groupId: payload.promotion.groupId
                })
            }

            let subState
            if (previewType === 'labels') {
                subState = 'accepted'
            } else {
                subState = 'available'
            }

            let subscriptions
            if (payload.equalPrices) {
                subscriptions = selectedPromotion.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx
                ].filter(el => el.state === subState)
            } else {
                subscriptions = selectedPromotion.subscriptions.filter(
                    el => el.state === subState
                )
            }

            // get searched merchant ids array
            const searchedMerchants = payload.shops
            subscriptions.forEach(el => {
                // select searched merchants only; if search input is empty, select all
                if (searchedMerchants.includes(el.merchant_id)) {
                    el.checked = payload.value
                }
            })

            let mutationName
            if (previewType === 'labels') {
                mutationName = 'SET_LABELPROMO_SELECTED_SHOPS'
            } else {
                mutationName = 'SET_PROMO_SELECTED_SHOPS'
            }
            commit(mutationName, {
                promoId: payload.promoId,
                subscriptions,
                equalPrices: payload.equalPrices,
                groupIdx: payload.groupIdx,
                groupId: payload.promotion.groupId
            })

            dispatch('setSelectAllMerchants', payload.value)
            dispatch('checkPricesErrors')
        },
        async downloadGroupMerchants({ dispatch, getters }, group) {
            const shouldFetch = !group?.showMerchantsOnAcceptView
            if (!shouldFetch) return

            const groupMerchants = await dispatch('fetchPromoGroupsMerchants', {
                group
            })
            return dispatch('updateSelectedGroup', {
                ...group,
                merchantIds: getters.getAvailableMerchants.map(m => {
                    const existingMerchant = group.merchantIds?.find(
                        merchant => {
                            return merchant.id === m.id
                        }
                    )

                    const selectedMerchants =
                        getters.getPromotionsFilters[
                            'promo|subscription|merchant_id'
                        ].value

                    const isDisabled = !groupMerchants.data.data.find(
                        gm =>
                            gm.id === m.id || selectedMerchants.includes(gm.id)
                    )

                    const isNotSelected = !selectedMerchants.includes(m.id)

                    let selected = false
                    if (
                        isDisabled ||
                        (isNotSelected && selectedMerchants.length)
                    ) {
                        selected = false
                    } else {
                        selected = existingMerchant
                            ? existingMerchant.selected
                            : true
                    }
                    return {
                        id: m.id,
                        selected,
                        disabled: isDisabled
                    }
                })
            })
        }
    },
    getters: {
        getMerchants: state => {
            return state.merchants.map(m => {
                let fullAddress = ''

                if (m.street) {
                    fullAddress += m.street
                    if (m.number) fullAddress += ` ${m.number}`
                }

                if (m.city) {
                    if (fullAddress) fullAddress += ', '
                    if (m.postcode) {
                        fullAddress += `${m.postcode} `
                    }
                    fullAddress += m.city
                }

                return {
                    ...m,
                    fullAddress
                }
            })
        },
        getAvailableMerchants: (state, getters) => {
            return getters.getMerchants.filter(
                el =>
                    el.state === 'active' ||
                    el.state === 'during_installation' ||
                    el.state === 'during_termination'
            )
        },
        getMerchantsForSelect: (state, getters) => {
            return getters.getAvailableMerchants.map(el => {
                return {
                    label: `${el.name}, ${el.fullAddress}`,
                    value: el.id,
                    nip: el.nip
                }
            })
        },
        getAllMerchantsForSelect: (state, getters) => {
            return getters.getMerchants.map(el => {
                return {
                    label: `${el.name}, ${el.fullAddress}`,
                    value: el.id,
                    nip: el.nip
                }
            })
        },
        getAllMerchantCrmsForSelect: (state, getters) => {
            return getters.getMerchants.filter(el => el.crm_id).map(el => {
                return {
                    label: `${el.name}, ${el.fullAddress}`,
                    value: el.crm_id,
                    nip: el.nip
                }
            })
        },
        getMerchantsNetworksForSelect: (state, getters) => {
            return getters.getAvailableMerchants.map(el => {
                let label = el.name
                if (el.fullAddress) label += `, ${el.fullAddress}`
                const loc = getters.getUserLocationById(el.location_id)
                if (loc) {
                    label += ` <strong>(${loc.network_name.replace(
                        '_Network',
                        ''
                    )})</strong>`
                }

                return {
                    label,
                    value: el.id
                }
            })
        },
        getLocationIdsForSelect: (state, getters) => {
            return getters.getMerchants.map(el => {
                return {
                    label: `${el.name}, ${el.fullAddress}`,
                    value: el.location_id
                }
            })
        },
        getMerchantById: (state, getters) => id => {
            return getters.getMerchants.find(item => item.id === id)
        },
        getMerchantByLocationId: (state, getters) => locationId => {
            return getters.getMerchants.find(merchant => merchant.location_id === locationId)
        },
        getMerchantSearch: state => {
            return state.merchantSearch
        },
        getMerchantIds: (state, getters) => {
            return getters.getMerchants.map(item => item.id)
        },
        getSelectAllMerchants: state => {
            return state.selectAllMerchants
        },
        getCurrentMerchantStatesForSelect: state => {
            const userStates = state.merchants.map(el => el.state)
            const uniqueStates = [...new Set(userStates)]

            const currentStates = Object.entries(merchantStates).filter(
                (key, value) => {
                    return uniqueStates.includes(key[0])
                }
            )
            return currentStates.map(el => {
                return {
                    label: el[1],
                    value: el[0]
                }
            })
        },
        getShopAddress: state => data => {
            let shopLabel = ''

            if (data.street) shopLabel += `ul. ${data.street}`
            if (data.number) shopLabel += ` ${data.number}`
            if (data.postcode) shopLabel += `, ${data.postcode}`
            if (data.city) shopLabel += ` ${data.city}`
            return shopLabel
        },
        getMerchantCrmId: (state, getters) => merchantId => {
            const merchant = getters.getMerchantById(merchantId)
            return merchant.crm_id
        },
        getLocationsByNetworkAlias: (_, getters) => alias => {
            const networkAlias = alias.replace(/_/g, '').toLowerCase()
            const merchants = getters.getAvailableMerchants || []

            const networkMerchants = merchants
                .filter(({ network }) => network.name.toLowerCase() === networkAlias)

            return networkMerchants.map(m =>
                ({ value: m.location_id, label: `${m.name}', '${m.fullAddress}` }))
        },
        getMerchantsByNetworkAlias: (_, getters) => alias => {
            const networkAlias = alias.replace(/_/g, '').toLowerCase()
            const merchants = getters.getAvailableMerchants || []

            const networkMerchants = merchants
                .filter(({ network }) => network?.name?.toLowerCase() === networkAlias)

            return networkMerchants.map(m =>
                ({ value: m.id, label: `${m.name}, ${m.fullAddress}` }))
        },

        getNetworkByMerchantId: (_, getters) => merchantId => {
            const merchant = getters.getMerchantById(merchantId)
            return merchant?.network
        }
    }
}
